module.exports = __webpack_public_path__ + "img/icon.66ee9235.svg";